import React from "react"
import { IConsultantNdfDetailModel } from "@common-models/*"

interface Props {
     data: IConsultantNdfDetailModel[]
     processingId: number | string | null
     editionMode: boolean
     onView: (ref: string, mime: string, id: number) => void
     onDownload: (ref: string, mime: string, id: number) => void
     onDelete: (id: number) => void
}

const HistoryList = ({ data, processingId, editionMode, onView, onDownload, onDelete }: Props) => (
     <>
          <div className="separator border-2 border-secondary border-opacity-25 my-10"></div>
          <h4 className="fw-bold text-gray-900 mb-8">
               <i className="fas fa-history text-muted me-3"></i>Historique des dépôts
          </h4>

          {data.map(depense => {
               // Calcul du total de la dépense [cite: 1]
               const total = ((depense.montantHt || 0) + (depense.montantTva || 0)).toFixed(2)
               const documents = depense.consultantNdfDocuments || []

               // Vérification de l'existence des montants [cite: 2]
               const hasHt = depense.montantHt !== null && depense.montantHt !== undefined
               const hasTva = depense.montantTva !== null && depense.montantTva !== undefined

               return (
                    <div key={depense.id} className="bg-body border border-secondary border-opacity-25 rounded px-5 py-4 mb-4 shadow-xs transition-all">
                         {/* En-tête de la dépense : Catégorie, Détails HT/TVA et Montant Total */}
                         <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-4 border-bottom border-secondary border-opacity-10 pb-3">
                              <div className="d-flex align-items-center mb-3 mb-md-0 flex-grow-1">
                                   <div className="symbol symbol-40px bg-light-primary border border-primary border-opacity-10 me-5 d-flex align-items-center justify-content-center">
                                        <i className="fas fa-receipt text-primary fs-5"></i>
                                   </div>
                                   <div className="d-flex flex-column me-8">
                                        <span className="text-gray-900 fw-bold fs-5">{depense.categorieLabel || "Frais divers"}</span>
                                        <span className="text-muted fs-7">{depense.date?.format("DD/MM/YYYY")}</span>
                                   </div>

                                   {/* Affichage conditionnel des badges HT et TVA */}
                                   {(hasHt || hasTva) && (
                                        <div className="text-gray-600 fs-7 fw-semibold d-none d-lg-block">
                                             {hasHt && <span className="badge badge-secondary me-2">HT: {depense.montantHt?.toFixed(2)}€</span>}
                                             {hasTva && <span className="badge badge-secondary">TVA: {depense.montantTva?.toFixed(2)}€</span>}
                                        </div>
                                   )}
                              </div>

                              <div className="d-flex align-items-center gap-4">
                                   {total && Number(total) > 0 && <span className="badge badge-light-dark fw-bolder fs-6 px-4 py-2">{total} €</span>}
                                   {editionMode && (
                                        <button
                                             className="btn btn-icon btn-sm btn-light-danger w-30px h-30px rounded-circle"
                                             disabled={processingId === depense.id}
                                             onClick={() => onDelete(depense.id!)}
                                        >
                                             {processingId === depense.id ? <span className="spinner-border spinner-border-sm"></span> : <i className="fas fa-trash fs-9"></i>}
                                        </button>
                                   )}
                              </div>
                         </div>

                         {/* Liste des documents associés à cette dépense  */}
                         <div className="d-flex flex-column gap-2">
                              {documents.map((doc, index) => (
                                   <div key={doc.id} className="d-flex align-items-center justify-content-between bg-light bg-opacity-50 rounded p-3">
                                        <div className="d-flex align-items-center flex-grow-1 overflow-hidden me-4">
                                             <i className="far fa-file-pdf text-danger me-3 fs-5"></i>
                                             <span className="text-gray-700 fs-7 fw-semibold text-truncate">{doc.fileName || `Justificatif n°${index + 1}`}</span>
                                        </div>
                                        <div className="d-flex gap-2 shrink-0">
                                             <button
                                                  className="btn btn-icon btn-xs btn-light-info w-30px h-30px rounded-circle"
                                                  disabled={processingId === `view-${doc.id}`}
                                                  onClick={() => onView(doc.googleDriveID, doc.googleDriveMimeType, doc.id)}
                                             >
                                                  {processingId === `view-${doc.id}` ? (
                                                       <span className="spinner-border spinner-border-sm"></span>
                                                  ) : (
                                                       <i className="fas fa-eye fs-9"></i>
                                                  )}
                                             </button>
                                             <button
                                                  className="btn btn-icon btn-xs btn-light-primary w-30px h-30px rounded-circle"
                                                  disabled={processingId === `dl-${doc.id}`}
                                                  onClick={() => onDownload(doc.googleDriveID, doc.googleDriveMimeType, doc.id)}
                                             >
                                                  {processingId === `dl-${doc.id}` ? (
                                                       <span className="spinner-border spinner-border-sm"></span>
                                                  ) : (
                                                       <i className="fas fa-download fs-9"></i>
                                                  )}
                                             </button>
                                        </div>
                                   </div>
                              ))}
                              {documents.length === 0 && <span className="text-muted fs-8 italic ps-2">Aucun document joint</span>}
                         </div>
                    </div>
               )
          })}
     </>
)

export default HistoryList
